import React, { memo } from 'react';
import { ReactComponent as OnCallBadgeIcon } from '../../assets/images/on-call-badge-icon.svg';

import './OnCallBadge.css';

const OnCallBadge = () => (
	<div className="on-call-badge">
		<span className="on-call-badge__icon">
			<OnCallBadgeIcon />
		</span>
		<span className="on-call-badge__label">On Call</span>
	</div>
);

export default memo(OnCallBadge);
